import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import './logo.scss';

const Logo = ({ logo }) => {
  const url = logo?.image?.url;
  let divStyle = {
    height: 'auto',
    maxWidth: '100%',
  };
  const logoClass = classNames({
    'sm-logo--container': true,
    'sm-logo--left': logo?.verticalAlignment === 'LEFT_TOP',
    'sm-logo--right': logo?.verticalAlignment === 'RIGHT_TOP',
    'sm-logo--center': logo?.verticalAlignment === 'CENTER',
  });

  if (logo?.size) {
    divStyle = {
      width: logo?.width,
      height: logo?.height,
      maxWidth: '100%',
    };
  }

  if (logo?.enabled) {
    return (
      <div className={logoClass} data-testid="Logo__Container">
        <img src={url} style={divStyle} alt="Survey Logo" />
      </div>
    );
  }
  return null;
};

Logo.propTypes = {
  logo: PropTypes.shape({
    height: PropTypes.number,
    size: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
    verticalAlignment: PropTypes.oneOf(['LEFT_TOP', 'RIGHT_TOP', 'CENTER', 'TOP']),
    width: PropTypes.number,
    enabled: PropTypes.bool,
  }),
};

Logo.defaultProps = {
  logo: null,
};

export default Logo;
